import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Variables/Global";
import axiosInstance from '../../../api/axiosConfig';

const ManageType = () => {
    var pId = useParams();
    var navigate = useNavigate();
     
    const [pageType, setPageType] = useState("Add");
    const [typeName, setTypeName] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [companies, setCompanies] = useState([]);

    const GetProductType = (productTypeId) =>{
        var config = {
            method: 'get',
            url: "ProductType/GetProductType/" + productTypeId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                document.title = response.data.productTypeName;
                setTypeName(response.data.productTypeName)
                setCompanyId(response.data.companyId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const GetCompanies = () => {
        var config = {
            method: 'get',
            url: "Company/GetCompany",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const submitForm = (e) => {
        e.preventDefault();
        if (IsValid()) {
            const body = { 
                productTypeName: typeName, 
                userId: localStorage.getItem("uTsReD"),
                companyId: companyId
            }
            if (pId.TypeId == "0") { //Add Product Type
                var config = {
                    method: 'post',
                    url: "ProductType/AddProductType",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if(response.status === 200){
                            toast.success("Type Added Successfully")
                            navigate("/Settings/Type")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
            else { // Update Product Type
                var config = {
                    method: 'put',
                    url: "ProductType/EditProductType/" + pId.TypeId,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if(response.status === 200){
                            toast.success("Type Updated Successfully")
                            navigate("/Settings/Type")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
        }
    }

    const IsValid = () => {
        if (typeName == "" && companyId == "0") {
            toast.error("Enter all required fields");
            return false;
        }
        else if (typeName == "") {
            toast.error("Enter Type Name");
            return false;
        }
        else if (companyId == "0") {
            toast.error("Select Company");
            return false;
        }
        return true;
    }

    useEffect(() => {
        GetCompanies();
        if (pId.TypeId != "0") {
            setPageType("Edit");
            GetProductType(pId.TypeId)
        }
    }, [])
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Types</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Settings/Type">Types</Link></li>
                                    <li className="breadcrumb-item active">{pageType} Types</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-12 col-md-6">
                                            <h4 className="card-title">{pageType} Type</h4>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <Link to="/Settings/Type" className="btn btn-secondary mr-3">Cancel</Link>
                                            <button className="btn btn-primary" onClick={(e) => submitForm(e)}>Submit</button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label className="col-md-2 col-form-label">Type Name</label>
                                            <input className="form-control" type="text" value={typeName} onChange={(e) => setTypeName(e.target.value)} required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="col-md-2 col-form-label">Company</label>
                                            <select className="form-control" value={companyId} onChange={(e) => setCompanyId(e.target.value)} required>
                                                <option value="0" key="0">-- Select Company Name --</option>
                                                {companies.length > 0 && (
                                                    companies.map((c, index) => {
                                                        return (<>
                                                            <option value={c.companyId} key={index}>{c.companyName}</option>
                                                        </>)
                                                    })
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ManageType;